import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { EditBusinessComponent } from 'app/components/business/editBusiness/editBusiness.component';
import { IBusinessView } from 'app/models/business/business';
import { IAdministrativeComplaintView, IComplaintView } from 'app/models/mainMenu/mainMenu';
import { ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ProcessComplaintService } from 'app/services/complaint/processComplaint.service';
import { ReportsService } from 'app/services/reports/reports.service';
import { ProcessNewBusinessComponent } from './processNewBusiness/processNewBusiness.component';
import { BusinessService } from 'app/services/business/business.service';

@Component({
  selector: 'processComplaint',
  templateUrl: './processComplaint.component.html',
  styleUrls: ['./processComplaint.component.scss']
})

export class ProcessComplaintComponent implements OnInit {

  filter: string = '';
  initialComplaint: IComplaintView = {} as IComplaintView;
  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;
  attachmentCount: number = 0;
  businessTypeList: ISelectItems[] = [];
  countyList: ISelectItems[] = [];
  showNext: boolean = false;
  showSuccess: boolean = false;
  searchList: IBusinessView[] = [];
  searchText: string = '';
  selected: string = '';
  newBusinessFlag: boolean = false;
  selectedBusiness: IBusinessView = {} as IBusinessView;

  displayedColumns: string[] = ['id', 'businessName', 'businessAddress1',
    'businessCity', 'businessZip', 'countyName', 'active', 'exempt'];
  dataSource = new MatTableDataSource<IBusinessView>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public processComplaintService: ProcessComplaintService,
    public adminService: AdminService,
    public sharedService: SharedService,
    private businessService: BusinessService,
    private modalService: MatDialog,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl(''),
    countyId: new UntypedFormControl('')
  });

  ngOnInit(): void {
    this.getComplaintData();
    this.businessTypeList = this.sharedService.businessTypeDropDownList;
    this.countyList = this.sharedService.countyDropDownList;
    this.showNext = false;
    this.newBusinessFlag = false;
  }

  getComplaintData() {
    this.processComplaintService.getComplaintData(this.processComplaintService.complaintId).subscribe({
      next: response => {
        this.currentComplaint = response;
        this.initialComplaint = this.currentComplaint.initialComplaint;
        this.attachmentCount = this.currentComplaint.files != null ? this.currentComplaint.files.length : 0;
        this.form.controls['countyId'].setValue(this.initialComplaint.county);
        this.form.controls['searchText'].setValue(this.initialComplaint.businessName);
        this.searchText = this.initialComplaint.businessName;
        this.getSearchBusinessData();
      },
      error: e => {
        this.sharedService.toastr.error("Could not get complaints data");
      },
    });
  }

  getSearchBusinessData() {
    this.adminService.businessAdminSearch = String(this.form.controls['searchText'].value);
    let searchText = String(this.form.controls['searchText'].value);
    if (searchText != null && searchText != '' && searchText.length < 3) {
      this.sharedService.toastr.error("Search text must be at least 3 characters");
      return;
    }
    this.processComplaintService.refineSearch(this.processComplaintService.complaintId,
      this.form.controls['countyId'].value, searchText).subscribe({
        next: response => {
          this.searchList = response.businessMatches;
          this.dataSource.data = this.searchList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.selected = '';
          this.searchText = this.form.controls['searchText'].value;
        },
        error: e => {
          this.sharedService.toastr.error("Could not get refined search data");
        },
      });
  }

  radioChange(id: string) {
    this.selected = id;
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  cantFindBusiness(event: any) {
    if (event.checked) {
      this.newBusiness();
    }
  }

  newBusiness() {
    this.adminService.currentBusiness = null;
    let biz: IBusinessView = {
      id: 0,
      businessName: this.initialComplaint.businessName,
      businessType: +this.initialComplaint.typeOfBusiness,
      active: true,
      exempt: false,
      businessAddress1: this.initialComplaint.address,
      businessAddress2: this.initialComplaint.address2,
      businessCity: this.initialComplaint.city,
      businessZip: this.initialComplaint.zip,
      businessZipExt: '',
      countyId: this.initialComplaint.county,
      exemptCertificateDate: '',
      exemptStatusId: 0,
      exemptTypeId: 0,
      exemptSmokingAllowed: false,
      exemptApprovedBy: '',
      exemptEnteredBy: '',


      exemptType: '',
      exemptStatus: '',
      canInspect: false,
      category: '',
      inViolation: false,
      countyName: '',
      stateId: 'OR',
      businessOwner: '',
      businessOwnerTitle: '',
      businessOwnerPhone: '',
      businessOwnerEmail: '',
      businessPhone: this.initialComplaint.businessPhone,
      businessPhoneExt: this.initialComplaint.businessPhoneExtension,
      contactName: '',
      contactTitle: '',
      contactEmail: '',
      notes: '',
      complaintId: this.currentComplaint.complaintId,
      associatedBusinessId: '',
      parentBusinessId: 0,
      parentBusinessName: '',
      parentBusinessContactFirstName: '',
      parentBusinessContactLastName: '',
      parentBusinessContactTitle: '',
      parentBusinessAddress: '',
      parentBusinessAddress2: '',
      parentBusinessCity: '',
      parentBusinessState: '',
      parentBusinessZip: '',
      parentBusinessZipExt: '',
      parentBusinessPhone: '',
      parentBusinessPhoneExt: '',
      parentBusinessEmail: '',
      useParentBusinessContact: false,
      totalComplaints: 0,
      complaints: [],
      comments: [],
      businessCorrespondence: null,
      lastUpdatedBy: '',
      lastUpdatedDate: new Date()
    };

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 600;
    config.data = {
      business: biz
    };
    const dialogRef = this.modalService.open(ProcessNewBusinessComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.processComplaintService.complaintId = this.currentComplaint.complaintId;
          this.sharedService.doRedirect('/complaint/determineComplaint');
        }
        else if (data != 'cancel') {
          this.gotoBusiness(+data);
        }
        this.newBusinessFlag = false;
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  next() {
    if (this.selected != '') {
      this.showNext = true;
      this.selectedBusiness = this.searchList.find(x => x.id == +this.selected);
    }
    else {
      this.sharedService.toastr.error("No Business match selected.");
    }
  }

  cancel() {
    this.showNext = false;
  }

  associate() {
    if (!this.selectedBusiness.active) {
      this.sharedService.openConfirm("This Business is INACTIVE. Are you sure you want to associate it with this complaint?");
      this.sharedService.confirmed().subscribe(
        confirmed => {
          if (confirmed) {
            this.completeAssociateBusiness();
          }
        }
      );
    }
    else {
      this.completeAssociateBusiness();
    }
  }

  completeAssociateBusiness() {
    this.processComplaintService.associateBusiness(this.currentComplaint.complaintId,
      this.selectedBusiness.id.toString()).subscribe(
        (result) => {
          this.showSuccess = true;
          this.sharedService.toastr.success("Business associated with Complaint.");
          this.sharedService.doRedirect('/complaint/determineComplaint');
        },
        error => {
          this.sharedService.toastr.error("Could not get Attachment:" + error.message);
        }
      );
  }

  typeOfBusiness(business: string): string {
    return this.sharedService.getBusinessType(business);
  }

  getCounty(county: string): string {
    return this.sharedService.convertCounty(county);
  }

  getAttachment(attachmentNumber: number) {
    let file = attachmentNumber == 1 ? this.currentComplaint.files[0] : this.currentComplaint.files[1];
    this.sharedService.getAttachment(file.id).subscribe(
      (result) => {
        this.sharedService.downloadFile(file.name, result);
      },
      error => {
        this.sharedService.toastr.error("Could not get Attachment:" + error.message);
      }
    );
  }

  gotoBusiness(businessId: number) {
    this.businessService.businessId = businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
  }
}

